import { ApiCollectionResponse, GetCollectionQueryParams } from '../../types';
import { ChatMessage } from '@tinct/core-api-models';
import { ApiError, tinctApi } from '../../api';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { GetChatAgentMessagesStaticFilter } from '../../endpoints/campaigns';

export const getChatAgentMessages = async (
  params: GetCollectionQueryParams<ChatMessage, GetChatAgentMessagesStaticFilter>,
): Promise<ApiCollectionResponse<ChatMessage>> => {
  return await tinctApi.campaigns.getCampaignChatAgentMessages(params);
};

export const useGetChatAgentMessages = (
  params: GetCollectionQueryParams<ChatMessage, GetChatAgentMessagesStaticFilter>,
  options?: Omit<
    UseQueryOptions<ApiCollectionResponse<ChatMessage>, ApiError>,
    'queryKey'
  >,
) =>
  useQuery({
    queryKey: ['campaigns', params.staticParams?.campaignId, 'chat-agent-messages', params],
    queryFn: () => getChatAgentMessages(params),
    ...options,
  });
